/* eslint-disable no-use-before-define */
import React from 'react'
import { trackPage, arrayFrom, } from '../twd'
import './report.css'
import Examples from './examples'
import Footer from './footer'
import Form from './form'
import NoAccount from './no-account'


const getAccounts = () =>
    arrayFrom(global.app.config.accounts)
        .filter(a => a.positionCount>0)

export default () => {
    trackPage('portfolio-report')

    const hasAccount = getAccounts().length>0

    return (
    <React.Fragment>
    <div className="report">
    {/* <div className="Top vertical-offset-lg"> */}
    <div className="container Top vertical-offset-lg">


    <div className="row vertical-offset-md" ></div>
    <div className="row vertical-offset-md xs-hide" ></div>

    <div className="row">
    <div className="col-md-7 prospect">
        <div className="row vertical-offset-md"></div>
        <div className="row vertical-offset-md xs-hide"></div>

        <h3>Fixed Income Portfolio Report</h3>
        <h1>Complete Insight,<br/>Clearly Delivered
        </h1>

        <h3>Without the right tools, managing and tracking a sizable bond
        portfolio can be a challenge. E*TRADE's new and improved<br/>
        Fixed Income Portfolio Report can give you the robust analysis<br/>
        you need—right at your fingertips.</h3>

        <div className="row vertical-offset-sm"></div>
    </div>

    <div className="col-md-4 half-col">
        {hasAccount ? <Form /> : <NoAccount />}
    </div>
    </div>

    <div className="row vertical-offset-md"></div>
    <div className="row vertical-offset-md xs-hide"></div>

    </div>
    {/* </div> */}

    <Examples />

    <Footer />

    </div>
    </React.Fragment>)
}
